import React from 'react'
import anxietyIcon from '../../assets/img/icons/man.png'
import relaxationIcon from '../../assets/img/icons/yoga.webp'
import { useTranslation } from 'react-i18next'

const Benefits = () => {
    const { t } = useTranslation();
    
    const benefits = [
        {
            icon: anxietyIcon,
            title: t('benefits.items.item1.title'),
            points: [
                t('benefits.items.item1.points.point1'),
                t('benefits.items.item1.points.point2'),
                t('benefits.items.item1.points.point3'),
                t('benefits.items.item1.points.point4'),
                t('benefits.items.item1.points.point5'),
                t('benefits.items.item1.points.point6'),
            ],
        },
        {
            icon: relaxationIcon,
            title: t('benefits.items.item2.title'),
            points: [
                t('benefits.items.item2.points.point1'),
                t('benefits.items.item2.points.point2'),
                t('benefits.items.item2.points.point3'),
                t('benefits.items.item2.points.point4'),
                t('benefits.items.item2.points.point5'),
            ],
        },
    ];

    return (
        <div className='py-35'>
            <div className="mx-auto h-full flex flex-col items-center justify-center text-center max-w-[940px]">
                <h2>{t('benefits.title')} <span className='text-primary'>{t('benefits.highlight')}</span></h2>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-5 mt-12'>
                    {benefits.map((benefit, index) => (
                        <div key={index} className='flex flex-col items-center gap-4 bg-gray-background px-10 py-8 rounded-xl'>
                            <div className='bg-white p-5 rounded-full'>
                                <img src={benefit.icon} alt={benefit.title} className="w-[48px] h-[48px]" />
                            </div>
                            <h3 className='text-3xl font-medium min-h-[135px] grid place-items-center'>{benefit.title}</h3>
                            <ul className='w-full'>
                                {benefit.points.map((point, pointIndex) => (
                                    <React.Fragment key={pointIndex}>
                                        <li className='py-4'>{point}</li>
                                        {pointIndex < benefit.points.length - 1 && (
                                            <li aria-hidden="true">
                                                <hr style={{ borderTop: '2px dashed #AEAAC7' }} />
                                            </li>
                                        )}
                                    </React.Fragment>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Benefits
